import { RouteConfig } from 'vue-router';

const Sjcj = () => import(/* webpackChunkName: "Szjx" */  './views/sjcj.vue');
const Zlkz = () => import(/* webpackChunkName: "Szjx" */  './views/zlkz/zlkz.vue');
const Jchj = () => import(/* webpackChunkName: "Szjx" */  './views/jchj/jchj.vue');



const routers: RouteConfig[] = [
    {
        path: 'sjcj',
        component: Sjcj,
    },
    {
        path: 'zlkz',
        component: Zlkz,
    },
    {
        path: 'jchj',
        component: Jchj,
    },
    {
        path: '',
        redirect: 'sjcj'
    }
];

export default routers;
